/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: OrdersQryListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: OrdersQryService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { OrdersQryData, OrdersQryService } from './OrdersQry.service';
import { OrdersQrySearchComponent }  from './OrdersQrySearch.component';

@Component({
	selector: 'my-OrdersQry',
	template: require('./OrdersQryList.component.html'),
	providers: [OrdersQryService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class OrdersQryListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	OrdersQryList: OrdersQryData[];
	newOrdersQry: OrdersQryData;
	selectedOrdersQry: OrdersQryData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(OrdersQrySearchComponent) filterComponent: OrdersQrySearchComponent;

	sortExpression: string = "OrderID";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private OrdersQryService: OrdersQryService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newOrdersQry = new OrdersQryData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.OrdersQryService.getAll().subscribe(record => this.OrdersQryList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getOrdersQryByPaging();

		/*
		this.OrdersQryList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getOrdersQry() {
		this.OrdersQryService.getAll()
			.subscribe(data => this.OrdersQryList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on OrdersQrySearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getOrdersQryByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getOrdersQryByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getOrdersQryByPaging();
	}
	
	// Get records by paging
	getOrdersQryByPaging() {
		this.OrdersQryService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.OrdersQryList=data.OrdersQryList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addOrdersQry() {
		this.OrdersQryService.addOrdersQryData(this.newOrdersQry).subscribe(record => console.log(record));
		this.getOrdersQry();
	}
  
	// Updates existing record
	updateOrdersQry() {
		this.OrdersQryService.updateOrdersQryData(this.selectedOrdersQry).subscribe(record => console.log(record));
		this.getOrdersQry();
	}

	// Deletes record with specified id
	deleteOrdersQry(id: string) {
		if (window.confirm('Are you sure you want to delete this OrdersQry?') == true)
		{
			this.OrdersQryService.deleteOrdersQry(id)
			.subscribe(data => this.getOrdersQry(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getOrdersQryByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getOrdersQryByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getOrdersQryByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getOrdersQryByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: OrdersQryData) {
		this.router.navigate(['/OrdersQry', item.OrderID]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: OrdersQryData) {
		this.router.navigate(['/OrdersQry/Details', item.OrderID]);
	}

	// Set record as selected
	SelectOrdersQry(item: OrdersQryData) {
		this.selectedOrdersQry = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: OrdersQryData) {
		return item.OrderID === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/OrdersQry/OrdersQryList.component.ts